import { Map as map } from 'immutable';
const C = require("../constants");

function ProductIngredientReducer(state = map(), action) {
    switch (action.type) {
        case C.PRODUCT_INGREDIENTS:
            return action.product_ingredients;
        case C.PRODUCT_INGREDIENTS_REMOVE:
            return state.filter(ingredient => {
                return ingredient.id !== action.product_ingredient
            });
        case C.PRODUCT_INGREDIENTS_ADD:
            return state.concat(action.product_ingredient);
        default:
            return state;
    }
}

export default ProductIngredientReducer;


// WEBPACK FOOTER //
// ./src/reducers/ProductIngredientReducer.js